import { useFormContext } from 'react-hook-form';
import { FormField, FormItem, FormMessage, Input, Label } from '@@/ui/primitives';

export function StringConstraints() {
  const form = useFormContext();

  return (
    <div className='flex flex-col gap-6 p-4'>
      <div className='flex flex-col gap-1'>
        <h4 className='text-sm font-semibold text-neutral-950'>String constraints</h4>
        <p className='text-xs text-neutral-600'>
          Set the minimum and maximum length for the string. It is recommended to have at least 1 character.
        </p>
      </div>
      <div className='flex items-start gap-4'>
        <FormField
          control={form.control}
          name='definition.minLength'
          render={({ field }) => (
            <FormItem className='flex flex-col gap-2'>
              <Label htmlFor='min-length'>Minimum Length</Label>
              <Input
                id='min-length'
                type='number'
                min='0'
                pattern='[0-9]*'
                inputMode='numeric'
                {...field}
                onChange={(e) => field.onChange(e.target.value ? parseInt(e.target.value, 10) : 0)}
                placeholder='No minimum'
                className='text-sm! bg-white shadow-none'
              />
              <FormMessage className='text-sm text-red-600' />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name='definition.maxLength'
          render={({ field }) => (
            <FormItem className='flex flex-col gap-2'>
              <Label htmlFor='max-length'>Maximum Length</Label>
              <Input
                id='max-length'
                type='number'
                min={form.watch('definition.required') ? '1' : '0'}
                {...field}
                value={field.value ?? ''}
                onChange={(e) => field.onChange(e.target.value ? parseInt(e.target.value, 10) : 0)}
                placeholder='No maximum'
                step={1}
                className='text-sm! bg-white shadow-none'
              />
              <FormMessage className='text-sm text-red-600' />
            </FormItem>
          )}
        />
      </div>
    </div>
  );
}
